import { Modal } from "../../../nq-component";

const defaultPops = {
  onCancel: () => {},
  onProceed: () => {},
};

function LogoutModal({ isOpen, onCancel, onProceed }) {
  return (
    <Modal
      style={{ background: "#ECEDF0" }}
      isOpen={isOpen}
      closable={true}
      onClosed={onCancel}
    >
      <Modal.Body>
        <div className="d-flex flex-column justify-content-center text-center gap-2 p-2">
          <i className="bi bi-exclamation-octagon fs-1 text-danger"></i>

          <div className="d-flex flex-column">
            <p className="fw-bold fs-2 m-0">Confirm</p>
            <p>Are you sure you want to sign out?</p>
          </div>

          <div className="d-flex gap-2 justify-content-end">
            <button
              className="btn border fw-bold"
              style={{ background: "#DADBE0" }}
              onClick={onCancel}
            >
              Cancel
            </button>

            <button
              className="bg-danger btn border fw-bold text-light"
              onClick={onProceed}
            >
              Yes, Logout<i className="bi bi-arrow-bar-right ms-2"></i>
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

LogoutModal.defaultPops = defaultPops;
export default LogoutModal;
